// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"568":"01be7be7","2327":"8274744d","2488":"202f4075","2678":"62da357c","5690":"b04e612a","8395":"d0bc6740"}[chunkId] + ".chunk.css";
};